import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Loader2, Eye } from "lucide-react";

// Live preview of the exact resend email (subject + HTML) for the chosen hero and
// personal message. Re-fetches whenever the pick changes; message edits are debounced.
export function ResendEmailPreview({ quoteId, hero, message, enabled }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!enabled || !quoteId) return;
    let alive = true;
    setLoading(true); setError("");
    const t = setTimeout(() => {
      api.post(`/admin/quote/${encodeURIComponent(quoteId)}/resend-preview`, { hero, message: message || "" })
        .then(r => { if (alive) setData(r.data); })
        .catch(e => { if (alive) setError(e?.response?.data?.detail || "Couldn't build the preview"); })
        .finally(() => { if (alive) setLoading(false); });
    }, 350);
    return () => { alive = false; clearTimeout(t); };
  }, [quoteId, hero, message, enabled]);

  if (!enabled) return null;

  return (
    <div data-testid="resend-email-preview" className="flex flex-col border border-[#E5E7EB] bg-white min-h-[420px]">
      <div className="px-3 py-2 border-b border-[#E5E7EB] bg-[#FAFAFA] flex items-center gap-2">
        <Eye size={12} className="text-[#C79A3B]" />
        <span className="text-[10px] uppercase tracking-widest text-[#6B7280] font-bold">What the client sees</span>
        {loading && <Loader2 size={12} className="animate-spin text-[#6B7280] ml-auto" />}
      </div>
      {data && (
        <div className="px-3 py-2 border-b border-[#E5E7EB] text-xs space-y-0.5">
          <div><span className="text-[#6B7280]">To:</span> <span data-testid="resend-preview-to" className="font-semibold text-[#12263A]">{data.to}</span></div>
          <div><span className="text-[#6B7280]">Subject:</span> <span data-testid="resend-preview-subject" className="font-semibold text-[#12263A]">{data.subject}</span></div>
        </div>
      )}
      {error && <div data-testid="resend-preview-error" className="p-3 text-xs text-[#C0392B]">{error}</div>}
      {data?.html && (
        <iframe data-testid="resend-preview-frame" title="Resend email preview" sandbox=""
          srcDoc={`<div style="padding:16px;background:#fff">${data.html}</div>`}
          className={`flex-1 w-full min-h-[380px] ${loading ? "opacity-50" : ""}`} />
      )}
    </div>
  );
}
